/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeesReferentialDto } from './FeesReferentialDto';
import {
    FeesReferentialDtoFromJSON,
    FeesReferentialDtoFromJSONTyped,
    FeesReferentialDtoToJSON,
    FeesReferentialDtoToJSONTyped,
} from './FeesReferentialDto';

/**
 * 
 * @export
 * @interface CustomBorrowerContractFunnelCommandDto
 */
export interface CustomBorrowerContractFunnelCommandDto {
    /**
     * List of custom fees to apply to the contract funnel
     * @type {Array<FeesReferentialDto>}
     * @memberof CustomBorrowerContractFunnelCommandDto
     */
    fees?: Array<FeesReferentialDto>;
}

/**
 * Check if a given object implements the CustomBorrowerContractFunnelCommandDto interface.
 */
export function instanceOfCustomBorrowerContractFunnelCommandDto(value: object): value is CustomBorrowerContractFunnelCommandDto {
    return true;
}

export function CustomBorrowerContractFunnelCommandDtoFromJSON(json: any): CustomBorrowerContractFunnelCommandDto {
    return CustomBorrowerContractFunnelCommandDtoFromJSONTyped(json, false);
}

export function CustomBorrowerContractFunnelCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomBorrowerContractFunnelCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fees': json['fees'] == null ? undefined : ((json['fees'] as Array<any>).map(FeesReferentialDtoFromJSON)),
    };
}

export function CustomBorrowerContractFunnelCommandDtoToJSON(json: any): CustomBorrowerContractFunnelCommandDto {
    return CustomBorrowerContractFunnelCommandDtoToJSONTyped(json, false);
}

export function CustomBorrowerContractFunnelCommandDtoToJSONTyped(value?: CustomBorrowerContractFunnelCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fees': value['fees'] == null ? undefined : ((value['fees'] as Array<any>).map(FeesReferentialDtoToJSON)),
    };
}

